window.addEventListener("beforeunload", function (e) {
    if ($('#modal-loader').length) {
        $('#modal-loader').show();
    }
});

document.addEventListener('resume', (event) => {
    // The page has been unfrozen: remove the spinner if it's active
    if ($('#modal-loader').length) {
        $('#modal-loader').hide();
    }

});


